// extracted by mini-css-extract-plugin
export default {"esport":"fiv_eEI2We4m3yMfNH6S","articles":"yd8GWAnrwU0M0qwoOKvy"};